<script setup>
import { ref } from 'vue'

const dialog = ref(false)
</script>

<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon color="secondary" dark v-bind="attrs" v-on="on">
        <v-icon v-on="on">fa-question-circle</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="text-h5 primary lighten-2"> Aide : Préparation de versement </v-card-title>

      <v-card-text class="pa-6">
        <ol id="myul">
          <li class="mb-2">Selectionnez les postes à verser sur le pannel de gauche.</li>
          <li class="mb-2">
            Fixez les montants des versements pour le mois entier (par défaut, le montant est fixé au montant théorique
            ± les ajustements du mois).
          </li>
          <li class="mb-2">
            Selectionnez les dates de versements sur le calendrier, les montants par versements seront automatiquement
            re-calculés.
          </li>
          <li class="mb-2">Cliquez sur <b>Déclarer les versements</b> pour les sauvegarder.</li>
        </ol>
        <v-divider />
        <p class="pa-2">
          Nota bene : vous pouvez consulter les versements du mois en cliquant sur <b>Versements du mois</b>
        </p>
        <v-divider />
        <small>Si cette notice n'est pas suffisamment claire, faites le savoir au support de Serenity</small>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="dialog = false">fermer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped></style>
